import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'category',
    standalone: false
})
export class CategoryPipe implements PipeTransform {

  transform(value: unknown): any {
    if (value) {
      if (value === 4) {
        return '3a'
      }
      return value;
    }
    return 0;
  }

}
